import { z } from 'zod';

/**
 * GameSession - Represents a single play session of a game.
 *
 * All sessions are anonymous — no PII is collected.
 * The anonymous_user_id is a generated identifier stored client-side.
 */
export const GameSessionSchema = z.object({
  id: z.string().uuid(),
  anonymous_user_id: z.string().min(1),
  game_id: z.string().uuid(),
  game_version: z.string().regex(/^\d+\.\d+\.\d+$/),
  started_at: z.string().datetime(),
  ended_at: z.string().datetime().nullable(),
  duration: z.number().min(0).nullable(),
  score: z.number().min(0).default(0),
  completed: z.boolean().default(false),
  metadata: z.record(z.unknown()).default({}),
});

export type GameSession = z.infer<typeof GameSessionSchema>;

export const GameSessionCreateInput = GameSessionSchema.omit({
  id: true,
  started_at: true,
  ended_at: true,
  duration: true,
  score: true,
  completed: true,
  metadata: true,
}).extend({
  metadata: z.record(z.unknown()).optional().default({}),
});

export type GameSessionCreateInput = z.infer<typeof GameSessionCreateInput>;

export const GameSessionEndInput = z.object({
  score: z.number().min(0).optional().default(0),
  completed: z.boolean().optional().default(false),
  metadata: z.record(z.unknown()).optional().default({}),
});

export type GameSessionEndInput = z.infer<typeof GameSessionEndInput>;
